export const cars = [
  {
    "Year": 2020,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2020,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Buick",
    "Model": "Envision",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "XT6",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "XT5",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "XT4",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "EcoSport",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Convertible"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Kona Electric",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Gladiator",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "BMW",
    "Model": "X7",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "CT6-V",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Hatchback, Sedan, Coupe"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chrysler",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "NEXO",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Genesis",
    "Model": "G70",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Cadillac",
    "Model": "CT5",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Elantra GT",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Ranger SuperCab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Expedition MAX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Kona",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Palisade",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Bolt EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Venue",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "INFINITI",
    "Model": "Q60",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Ranger SuperCrew",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Ioniq Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Jaguar",
    "Model": "E-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Honda",
    "Model": "HR-V",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Jaguar",
    "Model": "I-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Genesis",
    "Model": "G80",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Jaguar",
    "Model": "F-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Convertible"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Land Rover",
    "Model": "Discovery Sport",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Optima Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Optima Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Telluride",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Jeep",
    "Model": "Wrangler Unlimited",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2020,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Kia",
    "Model": "Stinger",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Land Rover",
    "Model": "Range Rover Velar",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "LC",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "UX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "GLS",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Lincoln",
    "Model": "Aviator",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "MAZDA",
    "Model": "CX-30",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mitsubishi",
    "Model": "Eclipse Cross",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Mitsubishi",
    "Model": "Mirage G4",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lincoln",
    "Model": "Corsair",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lincoln",
    "Model": "Nautilus",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Kicks",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "GLA",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Coupe, Wagon, Sedan, Convertible"
  },
  {
    "Year": 2020,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "GLE",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Mercedes-Benz",
    "Model": "GLC",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Mitsubishi",
    "Model": "Outlander PHEV",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Porsche",
    "Model": "Taycan",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Convertible"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Rogue Sport",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Porsche",
    "Model": "Cayenne Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "WRX",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "Ascent",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Corolla Hatchback",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "86",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Avalon Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "C-HR",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Camry Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Corolla Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "GR Supra",
    "Category": "Coupe"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Prius Prime",
    "Category": "Hatchback"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "RAV4 Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Highlander Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2020,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Toyota",
    "Model": "Yaris Hatchback",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "MDX Sport Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "RLX Sport Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2020,
    "Make": "Volvo",
    "Model": "XC40",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "Q8",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "RS 5",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Alfa Romeo",
    "Model": "4C Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2020,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV1992"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "4 Series",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "2 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Convertible, Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A4 allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "e-tron",
    "Category": "SUV"
  },
  {
    "Year": 2020,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "RS 3",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Alfa Romeo",
    "Model": "Stelvio",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Alfa Romeo",
    "Model": "Giulia",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "S3",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "i8",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "i3",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "M4",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "Regal Sportback",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X2",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "CTS-V",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X4",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "CT6",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "Regal TourX",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Bolt EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "CT6-V",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "M2",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "X7",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "Envision",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "Cascada",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "XT5",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "XT4",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "ATS-V",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 LD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chrysler",
    "Model": "Pacifica Hybrid",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "EcoSport",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500L",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Suburban 3500HD",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500c",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Expedition MAX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500 Abarth",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "124 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500X",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "FIAT",
    "Model": "500c Abarth",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Ranger SuperCab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit 150 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Genesis",
    "Model": "G90",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit 150 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit 350 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Ranger SuperCrew",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit 250 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit 350 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 1500 Limited Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Genesis",
    "Model": "G80",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Clarity Electric",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Genesis",
    "Model": "G70",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Civic Type R",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan, Hatchback"
  },
  {
    "Year": 2019,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Clarity Fuel Cell",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "HR-V",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Clarity Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Ioniq Electric",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Sonata Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Ioniq Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "Q60",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "NEXO",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Kona",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Kona Electric",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Elantra GT",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Ioniq Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Sonata Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "Q70",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "I-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "INFINITI",
    "Model": "QX30",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "XE",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Niro",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "E-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "F-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Jeep",
    "Model": "Wrangler Unlimited",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Niro Plug-in Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Optima Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Cadenza",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "K900",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Niro EV",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Optima Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Stinger",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Land Rover",
    "Model": "Range Rover Velar",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "LC",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Kia",
    "Model": "Soul EV",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Land Rover",
    "Model": "Discovery Sport",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Maserati",
    "Model": "Levante",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "MX-5 Miata RF",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "UX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "Nautilus",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "GLC",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "CX-3",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "MKC",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "A-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2019,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Maserati",
    "Model": "Ghibli",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG C-Class",
    "Category": "Sedan, Convertible, Coupe"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "GLS",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "GLA",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Coupe, Sedan, Wagon, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "CLS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "GLC Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLS",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Hyundai",
    "Model": "Santa Fe XL",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "GLE",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG E-Class",
    "Category": "Coupe, Convertible, Sedan, Wagon"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLA",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG S-Class",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "SL",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GT",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mitsubishi",
    "Model": "Mirage G4",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Metris Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-Maybach S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Mitsubishi",
    "Model": "Outlander PHEV",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLC Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Metris Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "SLC",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mitsubishi",
    "Model": "Eclipse Cross",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SLC",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLC",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SL",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "MINI",
    "Model": "Hardtop 2 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "MINI",
    "Model": "Hardtop 4 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLS",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "TITAN XD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Porsche",
    "Model": "718 Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Rogue Sport",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Kicks",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "TITAN Single Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "NV200 Taxi",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "TITAN XD Single Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "Versa Note",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Nissan",
    "Model": "TITAN XD King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "1500 Classic Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "1500 Classic Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "1500 Classic Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Porsche",
    "Model": "718 Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "ProMaster Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "ProMaster City",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "ProMaster Window Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "WRX",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Tesla",
    "Model": "Model X",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Corolla Hatchback",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Tesla",
    "Model": "Model 3",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "86",
    "Category": "Coupe"
  },
  {
    "Year": 2019,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "Ascent",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Highlander Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Camry Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "C-HR",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Avalon Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Mirai",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Atlas",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "RAV4 Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Prius Prime",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2019,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Golf SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Arteon",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "e-Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Golf GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Jetta GLI",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Convertible, Coupe, Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Golf Alltrack",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Golf R",
    "Category": "Hatchback"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "V60",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "V90",
    "Category": "Wagon"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "S90",
    "Category": "Sedan"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV2020"
  },
  {
    "Year": 2019,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2019,
    "Make": "Volvo",
    "Model": "XC40",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Alfa Romeo",
    "Model": "4C Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Aston Martin",
    "Model": "Vanquish S",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "RLX Sport Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Alfa Romeo",
    "Model": "Giulia",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Alfa Romeo",
    "Model": "4C",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Aston Martin",
    "Model": "DB11",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "MDX Sport Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A4 allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Alfa Romeo",
    "Model": "Stelvio",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A3 Sportback e-tron",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "RS 3",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "S3",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "S7",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "RS 7",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "RS 5",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Bentley",
    "Model": "Bentayga",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "4 Series",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "2 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "M4",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Bentley",
    "Model": "Flying Spur",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "Cascada",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2018,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X2",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "i3",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "M2",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X4",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "Envision",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "Regal Sportback",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Buick",
    "Model": "Regal TourX",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "CT6",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "ATS-V",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Bolt EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "CTS-V",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "XT5",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "City Express",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ferrari",
    "Model": "GTC4Lusso",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Ferrari",
    "Model": "488 GTB",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Chrysler",
    "Model": "Pacifica Hybrid",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Suburban 3500HD",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "124 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Ferrari",
    "Model": "812 Superfast",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Ferrari",
    "Model": "Portofino",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500 Abarth",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Ferrari",
    "Model": "488 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500c",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500c Abarth",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "C-MAX Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Expedition MAX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500L",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "FIAT",
    "Model": "500X",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "EcoSport",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit 350 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit 150 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit 150 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit 350 HD Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2018,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit 250 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Freightliner",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Transit 350 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Freightliner",
    "Model": "Sprinter WORKER Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Freightliner",
    "Model": "Sprinter 3500XD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Genesis",
    "Model": "G80",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Genesis",
    "Model": "G90",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Civic Type R",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Santa Fe Sport",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Ioniq Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "HR-V",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Hatchback, Sedan"
  },
  {
    "Year": 2018,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Ioniq Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Ioniq Electric",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Clarity Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Elantra GT",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Clarity Fuel Cell",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Sonata Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Clarity Electric",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Sonata Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Jaguar",
    "Model": "F-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2018,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "INFINITI",
    "Model": "Q60",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Jaguar",
    "Model": "E-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "INFINITI",
    "Model": "Q70",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Hyundai",
    "Model": "Kona",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Jaguar",
    "Model": "XE",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Jeep",
    "Model": "Wrangler Unlimited",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Forte5",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Optima Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Cadenza",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Soul EV",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Niro Plug-in Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "INFINITI",
    "Model": "QX30",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Optima Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Stinger",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Land Rover",
    "Model": "Range Rover Velar",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Niro",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Lamborghini",
    "Model": "Huracan",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Land Rover",
    "Model": "Discovery Sport",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "LC",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "MKC",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2018,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Maserati",
    "Model": "Levante",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "GLS",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "MX-5 Miata RF",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "GLC Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lotus",
    "Model": "Evora 400",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "McLaren",
    "Model": "570GT",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "GLE",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "McLaren",
    "Model": "720S",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Maserati",
    "Model": "Ghibli",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "McLaren",
    "Model": "570S",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "CLS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "MAZDA",
    "Model": "CX-3",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Convertible, Coupe, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLC Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SLC",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SL",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLC",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLS",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "GLA",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "GLC",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "SLC",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Metris Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLA",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLS",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG C-Class",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Metris WORKER Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG S-Class",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Metris Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Metris WORKER Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-Maybach S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "SL",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 XD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "MINI",
    "Model": "Hardtop 2 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Mitsubishi",
    "Model": "Outlander PHEV",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "MINI",
    "Model": "Hardtop 4 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter WORKER Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mitsubishi",
    "Model": "Mirage G4",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Mitsubishi",
    "Model": "Eclipse Cross",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "TITAN XD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "TITAN XD Single Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Kicks",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "TITAN XD King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "TITAN Single Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Rogue Sport",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Porsche",
    "Model": "718 Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Versa Note",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Porsche",
    "Model": "718 Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "smart",
    "Model": "fortwo electric drive",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Rolls-Royce",
    "Model": "Wraith",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "ProMaster Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Tesla",
    "Model": "Model 3",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Rolls-Royce",
    "Model": "Dawn",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "ProMaster City",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "smart",
    "Model": "fortwo electric drive cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "ProMaster Window Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "WRX",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2018,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Avalon Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "86",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "C-HR",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Corolla iM",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Mirai",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Highlander Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Camry Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Tesla",
    "Model": "Model X",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Prius Prime",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "RAV4 Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Golf GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Volvo",
    "Model": "V90",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Golf R",
    "Category": "Hatchback"
  },
  {
    "Year": 2018,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Atlas",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Golf Alltrack",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Volvo",
    "Model": "V60",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Alfa Romeo",
    "Model": "Giulia",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Yaris iA",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "e-Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "MDX Sport Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Golf SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2018,
    "Make": "Volvo",
    "Model": "S90",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2018,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2018,
    "Make": "Volkswagen",
    "Model": "Tiguan Limited",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "RLX Sport Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Alfa Romeo",
    "Model": "4C",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A4 allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Aston Martin",
    "Model": "Rapide S",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A3 Sportback e-tron",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Aston Martin",
    "Model": "Vanquish",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Aston Martin",
    "Model": "DB11",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A5 Sport",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "RS 3",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "S3",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "RS 7",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "S7",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X4",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Bentley",
    "Model": "Bentayga",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Bentley",
    "Model": "Flying Spur",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "i8",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "4 Series",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "2 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "M2",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "i3",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "Envision",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "Cascada",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "M4",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "ATS-V",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2017,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "CT6",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Buick",
    "Model": "Verano",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Bolt EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "CTS-V",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "XT5",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "City Express",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Ferrari",
    "Model": "GTC4Lusso",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "SS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Suburban 3500HD",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ferrari",
    "Model": "F12berlinetta",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "124 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500 Abarth",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Chrysler",
    "Model": "Pacifica Hybrid",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ferrari",
    "Model": "488 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Ferrari",
    "Model": "488 GTB",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500c",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "C-MAX Energi",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500L",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500c Abarth",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "FIAT",
    "Model": "500X",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "C-MAX Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit 350 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit 150 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit 350 HD Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit 150 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Genesis",
    "Model": "G90",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter 3500XD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Genesis",
    "Model": "G80",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit 250 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter WORKER Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ford",
    "Model": "Transit 350 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Freightliner",
    "Model": "Sprinter WORKER Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Acadia Limited",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Ioniq Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Elantra GT",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "HR-V",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Civic Type R",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan, Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Santa Fe Sport",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Sonata Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "QX30",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "QX70",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Sonata Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Tucson Fuel Cell",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "Q70",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Jaguar",
    "Model": "F-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "INFINITI",
    "Model": "Q60",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Jaguar",
    "Model": "XE",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Hyundai",
    "Model": "Ioniq Electric",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Wrangler Unlimited",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "K900",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Cadenza",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Niro",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Forte5",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Optima Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Lamborghini",
    "Model": "Huracan",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Soul EV",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Optima Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Land Rover",
    "Model": "Discovery Sport",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "CX-3",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG C-Class",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "MX-5 Miata RF",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Maserati",
    "Model": "Ghibli",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "McLaren",
    "Model": "570S",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Maserati",
    "Model": "Levante",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Convertible, Sedan, Coupe, Wagon"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "MKC",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "GLC Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "GLE",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "GLC",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Lotus",
    "Model": "Evora 400",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2017,
    "Make": "McLaren",
    "Model": "570GT",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "CLS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "B-Class",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG E-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "GLA",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLS",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLS",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SL",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLC",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLA",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "SL",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Metris Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "GLS",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-Maybach S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 XD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Metris WORKER Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLC Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG S-Class",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GT",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Convertible, Coupe"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Metris WORKER Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "SLC",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SLC",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Metris Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter WORKER Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter WORKER Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "MINI",
    "Model": "Hardtop 2 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "MINI",
    "Model": "Hardtop 4 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Mitsubishi",
    "Model": "i-MiEV",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Mitsubishi",
    "Model": "Mirage G4",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Rogue Sport",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "TITAN XD Single Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "TITAN XD King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "Versa Note",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "TITAN XD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Porsche",
    "Model": "718 Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Nissan",
    "Model": "TITAN Single Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Porsche",
    "Model": "718 Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "ProMaster Window Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "ProMaster Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "smart",
    "Model": "fortwo cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Avalon Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "smart",
    "Model": "fortwo electric drive",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Rolls-Royce",
    "Model": "Dawn",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Tesla",
    "Model": "Model X",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "ProMaster City",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "smart",
    "Model": "fortwo electric drive cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 2017,
    "Make": "Rolls-Royce",
    "Model": "Wraith",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "86",
    "Category": "Coupe"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Mirai",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Prius Prime",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Prius v",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Subaru",
    "Model": "WRX",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Highlander Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Corolla iM",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Camry Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "RAV4 Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Yaris iA",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "e-Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Golf Alltrack",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Golf SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Volvo",
    "Model": "V90",
    "Category": "Wagon"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Golf R",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Golf GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Tiguan Limited",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2017,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2017,
    "Make": "Volvo",
    "Model": "S90",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Aston Martin",
    "Model": "DB9 GT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Aston Martin",
    "Model": "Rapide S",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Aston Martin",
    "Model": "Vanquish",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Acura",
    "Model": "RLX Sport Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2017,
    "Make": "Volvo",
    "Model": "V60",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A3 Sportback e-tron",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Alfa Romeo",
    "Model": "4C Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Alfa Romeo",
    "Model": "4C",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "S3",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "RS 7",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Bentley",
    "Model": "Flying Spur",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "S7",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "i3",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "4 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "M2",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "2 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X4",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "M4",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "Cascada",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "Verano",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "i8",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "ELR",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "Envision",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "ATS-V",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2016,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "CTS-V",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Cadillac",
    "Model": "CT6",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Cruze Limited",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "City Express",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Impala Limited",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Malibu Limited",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Dart",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Suburban 3500HD",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Spark EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "SS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ferrari",
    "Model": "488 GTB",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Ferrari",
    "Model": "F12berlinetta",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "FIAT",
    "Model": "500L",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "FIAT",
    "Model": "500X",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ferrari",
    "Model": "FF",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Ferrari",
    "Model": "488 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "FIAT",
    "Model": "500c",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "C-MAX Energi",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "FIAT",
    "Model": "500 Abarth",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2016,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "C-MAX Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit 150 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit 150 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit 350 HD Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit 350 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Freightliner",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit 350 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit 250 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "HR-V",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Honda",
    "Model": "CR-Z",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Sonata Plug-in Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Equus",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Elantra GT",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Santa Fe Sport",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Tucson Fuel Cell",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Hyundai",
    "Model": "Sonata Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "INFINITI",
    "Model": "QX70",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "INFINITI",
    "Model": "Q70",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Cadenza",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "K900",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Forte Koup",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Lamborghini",
    "Model": "Huracan",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Forte5",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Optima Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Maserati",
    "Model": "Ghibli",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Kia",
    "Model": "Soul EV",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Land Rover",
    "Model": "Discovery Sport",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "MKC",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "McLaren",
    "Model": "650S",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "B-Class",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "McLaren",
    "Model": "675LT",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "MAZDA",
    "Model": "CX-3",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Coupe, Wagon, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "McLaren",
    "Model": "570S",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "GLA",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "GLC",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG CLA",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "GLE",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "SL",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "GLE Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SL",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Metris Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLA",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-Maybach S 600",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "SLK",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Metris Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GT",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG SLK",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG GLE Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "MINI",
    "Model": "Hardtop 2 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "MINI",
    "Model": "Paceman",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "MINI",
    "Model": "Hardtop 4 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mitsubishi",
    "Model": "i-MiEV",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "TITAN XD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Rolls-Royce",
    "Model": "Dawn",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "ProMaster Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "NV200 Taxi",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Nissan",
    "Model": "Versa Note",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Scion",
    "Model": "iA",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "ProMaster Window Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Rolls-Royce",
    "Model": "Wraith",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "ProMaster City",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan, Convertible, Coupe"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "WRX",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "smart",
    "Model": "fortwo electric drive",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Scion",
    "Model": "iM",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Scion",
    "Model": "FR-S",
    "Category": "Coupe"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Tesla",
    "Model": "Model X",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Mirai",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Prius v",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "e-Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Golf GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Golf SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Golf R",
    "Category": "Hatchback"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2016,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2016,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2016,
    "Make": "Volvo",
    "Model": "V60",
    "Category": "Wagon"
  },
  {
    "Year": 2016,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Alfa Romeo",
    "Model": "4C Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Aston Martin",
    "Model": "Rapide S",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Alfa Romeo",
    "Model": "4C",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Aston Martin",
    "Model": "Vanquish",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "RS 5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "S3",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "RS 7",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "4 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Audi",
    "Model": "S7",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "i8",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "i3",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "2 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Bentley",
    "Model": "Flying Spur",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "M4",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Buick",
    "Model": "Verano",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X4",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Captiva Sport",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "City Express",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Impala Limited",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "SS",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Spark EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Dart",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ferrari",
    "Model": "458 Italia",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ferrari",
    "Model": "F12berlinetta",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Ferrari",
    "Model": "458 Speciale",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Ferrari",
    "Model": "458 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Ferrari",
    "Model": "FF",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "FIAT",
    "Model": "500L",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "FIAT",
    "Model": "500c",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "C-MAX Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "C-MAX Energi",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "FIAT",
    "Model": "500 Abarth",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2015,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Freightliner",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit 150 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Focus ST",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit 350 HD Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit 150 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit 350 Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit 350 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ford",
    "Model": "Transit 250 Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Crosstour",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "CR-Z",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Elantra GT",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Equus",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "Q40",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "QX70",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Tucson Fuel Cell",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Santa Fe Sport",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "Q70",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Forte5",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "K900",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "Q60",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Maserati",
    "Model": "Ghibli",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Cadenza",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Optima Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "B-Class",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Forte Koup",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lamborghini",
    "Model": "Huracan",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Land Rover",
    "Model": "Discovery Sport",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Kia",
    "Model": "Soul EV",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "CLA-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Convertible, Wagon, Coupe, Sedan"
  },
  {
    "Year": 2015,
    "Make": "Lincoln",
    "Model": "MKC",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "GLK-Class",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "McLaren",
    "Model": "650S",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "GLA-Class",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "SLS-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Paceman",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Hardtop 4 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Roadster",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "MINI",
    "Model": "Hardtop 2 Door",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Mitsubishi",
    "Model": "Lancer Evolution",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "NV200 Taxi",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Rogue Select",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "ProMaster Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Rolls-Royce",
    "Model": "Wraith",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "ProMaster City",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Scion",
    "Model": "iQ",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "XV Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "C/V Tradesman",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "smart",
    "Model": "fortwo electric drive",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Ram",
    "Model": "ProMaster Window Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 2015,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "WRX",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Scion",
    "Model": "FR-S",
    "Category": "Coupe"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Prius Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Prius v",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "e-Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Golf R",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Golf SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Golf GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Volvo",
    "Model": "V60",
    "Category": "Wagon"
  },
  {
    "Year": 2015,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2015,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Aston Martin",
    "Model": "Vanquish",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2015,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2014,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "RLX",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Aston Martin",
    "Model": "Rapide S",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2015,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "SQ5",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "RS 5",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "2 Series",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Acura",
    "Model": "RLX Sport Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "RS 7",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "S7",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Bentley",
    "Model": "Flying Spur",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "i8",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "i3",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Buick",
    "Model": "Verano",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "4 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "ELR",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Impala Limited",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Captiva Sport",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Spark EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "SS",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Dart",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Ferrari",
    "Model": "FF",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Ferrari",
    "Model": "F12berlinetta",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ferrari",
    "Model": "458 Speciale",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "FIAT",
    "Model": "500c",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Ferrari",
    "Model": "458 Italia",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Ferrari",
    "Model": "458 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "FIAT",
    "Model": "500 Abarth",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2014,
    "Make": "FIAT",
    "Model": "500L",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "C-MAX Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "C-MAX Energi",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Focus ST",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Freightliner",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 1500 Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Crosstour",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "CR-Z",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Hatchback, Coupe"
  },
  {
    "Year": 2014,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Santa Fe Sport",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Equus",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "Q60",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "Q70",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "QX60",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "QX70",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Jaguar",
    "Model": "F-TYPE",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan, Coupe, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Cadenza",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "MAZDA2",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Lotus",
    "Model": "Evora",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Maserati",
    "Model": "Ghibli",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "B-Class",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2014,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "McLaren",
    "Model": "MP4-12C",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "CLA-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "GLK-Class",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon, Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "cube",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Mitsubishi",
    "Model": "i-MiEV",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "SLS-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Roadster",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Paceman",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Hardtop",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Rogue Select",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "C/V Tradesman",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "smart",
    "Model": "fortwo electric drive",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "ProMaster 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "ProMaster 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Scion",
    "Model": "iQ",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Scion",
    "Model": "FR-S",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "ProMaster 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "SRT",
    "Model": "Viper",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Rolls-Royce",
    "Model": "Wraith",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "XV Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Prius v",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Prius Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2014,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2014,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Routan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2014,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Jetta SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2014,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2014,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2014,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Acura",
    "Model": "ZDX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "1 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "S7",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Sedan, Convertible, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "RS 5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Buick",
    "Model": "Verano",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "XTS",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 2013,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Cadillac",
    "Model": "ATS",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Captiva Sport",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Ferrari",
    "Model": "FF",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "C-MAX Energi",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Ferrari",
    "Model": "458 Spider",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "FIAT",
    "Model": "500e",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Ferrari",
    "Model": "F12berlinetta",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "C-MAX Hybrid",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Dodge",
    "Model": "Dart",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ferrari",
    "Model": "458 Italia",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Freightliner",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Focus ST",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Fusion Energi",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Freightliner",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Crosstour",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "CR-Z",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "INFINITI",
    "Model": "EX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Equus",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Coupe, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Santa Fe Sport",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "INFINITI",
    "Model": "JX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan, Hatchback, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "MAZDA2",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "McLaren",
    "Model": "MP4-12C",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Lotus",
    "Model": "Evora",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Coupe, Wagon, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "GLK-Class",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Hardtop",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "SLS-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Roadster",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "NV200",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Paceman",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "cube",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Scion",
    "Model": "FR-S",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "C/V Tradesman",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "XV Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2013,
    "Make": "SRT",
    "Model": "Viper",
    "Category": "Coupe"
  },
  {
    "Year": 2013,
    "Make": "Suzuki",
    "Model": "Kizashi",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Scion",
    "Model": "iQ",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "smart",
    "Model": "fortwo electric drive",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Prius v",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Prius Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "C30",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Routan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "Jetta SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2013,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2013,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2012,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Acura",
    "Model": "ZDX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Aston Martin",
    "Model": "Rapide",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Aston Martin",
    "Model": "DBS",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Aston Martin",
    "Model": "Virage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "1 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Convertible, Wagon, Sedan"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Buick",
    "Model": "Verano",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 2012,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Captiva Sport",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Sonic",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Caliber",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Ferrari",
    "Model": "458 Italia",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "FIAT",
    "Model": "500",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Fisker",
    "Model": "Karma",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ferrari",
    "Model": "FF",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Crosstour",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Equus",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Honda",
    "Model": "CR-Z",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "INFINITI",
    "Model": "EX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Veracruz",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan, Hatchback, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Lamborghini",
    "Model": "Aventador",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Land Rover",
    "Model": "Range Rover Evoque",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "HS",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "LFA",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lotus",
    "Model": "Evora",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2012,
    "Make": "McLaren",
    "Model": "MP4-12C",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "CX-7",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "MAZDA2",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "MINI",
    "Model": "Hardtop",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "GLK-Class",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "SLS-Class",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Mitsubishi",
    "Model": "i-MiEV",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "MINI",
    "Model": "Roadster",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2012,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "MINI",
    "Model": "Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "cube",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "NV3500 HD Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "NV1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "NV2500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "C/V",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Convertible, Coupe, Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2011,
    "Make": "Acura",
    "Model": "ZDX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Prius v",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Scion",
    "Model": "iQ",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Suzuki",
    "Model": "Equator Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Prius c",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Suzuki",
    "Model": "Equator Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Suzuki",
    "Model": "Kizashi",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Beetle",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Prius Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Routan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Jetta SportWagen",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "C30",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2012,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Aston Martin",
    "Model": "Rapide",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2012,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2011,
    "Make": "Aston Martin",
    "Model": "DBS",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Convertible, Coupe, Sedan"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Bentley",
    "Model": "Mulsanne",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "1 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "DTS",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Buick",
    "Model": "Lucerne",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Cruze",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "HHR",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Chrysler",
    "Model": "200",
    "Category": "Convertible, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ferrari",
    "Model": "599 GTB Fiorano",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Volt",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ferrari",
    "Model": "599 GTO",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Ferrari",
    "Model": "612 Scaglietti",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Caliber",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ferrari",
    "Model": "458 Italia",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Nitro",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Fiesta",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "CR-Z",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Accord Crosstour",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2011,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Equus",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "INFINITI",
    "Model": "EX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan, Coupe, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "CT",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Hyundai",
    "Model": "Veracruz",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "HS",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lotus",
    "Model": "Evora",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "IS F",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Lotus",
    "Model": "Exige",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "MAZDA2",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "CX-7",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Coupe, Convertible, Sedan, Wagon"
  },
  {
    "Year": 2011,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Mercury",
    "Model": "Milan",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "GLK-Class",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "Sprinter 2500 Crew",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "MINI",
    "Model": "Hardtop",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Mercedes-Benz",
    "Model": "SLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "cube",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "MINI",
    "Model": "Countryman",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "JUKE",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Saab",
    "Model": "9-4X",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Suzuki",
    "Model": "Equator Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Sedan, Convertible, Wagon"
  },
  {
    "Year": 2011,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "Dakota Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "Dakota Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2011,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Suzuki",
    "Model": "Equator Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Ram",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Suzuki",
    "Model": "Kizashi",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2011,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "C30",
    "Category": "Hatchback"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2011,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Aston Martin",
    "Model": "DBS",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Acura",
    "Model": "ZDX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2011,
    "Make": "Volkswagen",
    "Model": "Routan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "1 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Aston Martin",
    "Model": "Rapide",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "X5 M",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Bentley",
    "Model": "Azure T",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Bentley",
    "Model": "Brooklands",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Buick",
    "Model": "Lucerne",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "HHR",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "X6 M",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Cobalt",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Cadillac",
    "Model": "DTS",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Caliber",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Dakota Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Dakota Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Nitro",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Ferrari",
    "Model": "458 Italia",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Ferrari",
    "Model": "612 Scaglietti",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "E150 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ferrari",
    "Model": "599 GTB Fiorano",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Transit Connect Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Transit Connect Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Accord Crosstour",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "HUMMER",
    "Model": "H3T",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Genesis Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "HUMMER",
    "Model": "H3",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2010,
    "Make": "INFINITI",
    "Model": "EX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Veracruz",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Rondo",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Jeep",
    "Model": "Commander",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Lamborghini",
    "Model": "Murcielago",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Land Rover",
    "Model": "LR4",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Convertible, Sedan"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lotus",
    "Model": "Exige",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "HS",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "IS F",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Lincoln",
    "Model": "MKT",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Lotus",
    "Model": "Evora",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "CX-7",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "MINI",
    "Model": "Hardtop",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mercury",
    "Model": "Milan",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Mercedes-Benz",
    "Model": "GLK-Class",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Wagon, Convertible, Sedan"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "cube",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Pontiac",
    "Model": "G6",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Pontiac",
    "Model": "G3",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Rolls-Royce",
    "Model": "Ghost",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Suzuki",
    "Model": "Equator Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Suzuki",
    "Model": "Equator Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Saturn",
    "Model": "Outlook",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2010,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Suzuki",
    "Model": "Kizashi",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Routan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "C30",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2010,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2010,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Convertible, Wagon, Sedan"
  },
  {
    "Year": 2009,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Aston Martin",
    "Model": "DBS",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Bentley",
    "Model": "Arnage",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Bentley",
    "Model": "Brooklands",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Convertible, Coupe, Wagon"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "1 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Bentley",
    "Model": "Azure",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Cobalt",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "DTS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "XLR",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Buick",
    "Model": "Lucerne",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "HHR",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Dakota Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Journey",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Dakota Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chrysler",
    "Model": "Aspen",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ferrari",
    "Model": "430 Scuderia",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ferrari",
    "Model": "599 GTB Fiorano",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Caliber",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Ferrari",
    "Model": "California",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Nitro",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Ram 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "E150 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Ferrari",
    "Model": "612 Scaglietti",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ferrari",
    "Model": "F430",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Flex",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Ford",
    "Model": "Taurus X",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "HUMMER",
    "Model": "H3T",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Veracruz",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "HUMMER",
    "Model": "H3",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Amanti",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Rondo",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Jeep",
    "Model": "Commander",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Hyundai",
    "Model": "Genesis",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "INFINITI",
    "Model": "EX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Borrego",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Jaguar",
    "Model": "XF",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "Lamborghini",
    "Model": "Murcielago",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "IS F",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Land Rover",
    "Model": "LR3",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Lincoln",
    "Model": "MKS",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "CX-7",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Lotus",
    "Model": "Exige",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "B-Series Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "SLR McLaren",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "370Z",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Mercury",
    "Model": "Milan",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "GT-R",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Mitsubishi",
    "Model": "Raider Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2009,
    "Make": "MINI",
    "Model": "Hardtop",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "cube",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Mitsubishi",
    "Model": "Raider Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "G6 (2009.5)",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "Solstice",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2009,
    "Make": "Saturn",
    "Model": "Outlook",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "G8",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "G6",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Sedan, Convertible, Wagon"
  },
  {
    "Year": 2009,
    "Make": "Saturn",
    "Model": "Aura",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Saab",
    "Model": "9-7X",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "Torrent",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Convertible, Coupe, Sedan"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "G5",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Pontiac",
    "Model": "G3",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2009,
    "Make": "Saturn",
    "Model": "SKY",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Suzuki",
    "Model": "Equator Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Suzuki",
    "Model": "XL7",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Suzuki",
    "Model": "Equator Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "CC",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Rabbit",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Touareg 2",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "GLI",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Routan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "C30",
    "Category": "Hatchback"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "R8",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "A5",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Convertible, Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2009,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "RS 4",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Aston Martin",
    "Model": "DBS",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan, Wagon, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "1 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "X6",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Wagon, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Bentley",
    "Model": "Arnage",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "Z4 M",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Buick",
    "Model": "Lucerne",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Bentley",
    "Model": "Azure",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "XLR",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "DTS",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "BMW",
    "Model": "Alpina B7",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Cobalt",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "HHR",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Malibu (Classic)",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "Aspen",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Uplander Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "Crossfire",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Chevrolet",
    "Model": "Uplander Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Caliber",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Nitro",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Dakota Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Magnum",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 1500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Dakota Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ferrari",
    "Model": "612 Scaglietti",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ferrari",
    "Model": "F430",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Ram 3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Ferrari",
    "Model": "599 GTB Fiorano",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Ferrari",
    "Model": "430 Scuderia",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "E150 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Taurus X",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "F450 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2008,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Entourage",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Isuzu",
    "Model": "i-370 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "HUMMER",
    "Model": "H3",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Veracruz",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Isuzu",
    "Model": "i-290 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "INFINITI",
    "Model": "EX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Jeep",
    "Model": "Commander",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Land Rover",
    "Model": "LR2",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lamborghini",
    "Model": "Murcielago LP640",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Amanti",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Rondo",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Isuzu",
    "Model": "Ascender",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Isuzu",
    "Model": "i-370 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Land Rover",
    "Model": "LR3",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "IS F",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Maserati",
    "Model": "GranTurismo",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Lotus",
    "Model": "Exige S",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "B-Series Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Lincoln",
    "Model": "Mark LT",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "MAZDA",
    "Model": "CX-7",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "MINI",
    "Model": "Clubman",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Mercury",
    "Model": "Milan",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "SLR McLaren",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Raider Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "G8",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "G6",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "G5",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "Torrent",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Sedan, Convertible, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Raider Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2008,
    "Make": "smart",
    "Model": "fortwo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Subaru",
    "Model": "Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Scion",
    "Model": "xD",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Suzuki",
    "Model": "XL7",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Saturn",
    "Model": "Astra",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Saturn",
    "Model": "Outlook",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2008,
    "Make": "Saturn",
    "Model": "Aura",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Suzuki",
    "Model": "Reno",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Saturn",
    "Model": "SKY",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Saab",
    "Model": "9-7X",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Pontiac",
    "Model": "Solstice",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2008,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "R32",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "GLI",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Suzuki",
    "Model": "Forenza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2008,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "Rabbit",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Volkswagen",
    "Model": "Touareg 2",
    "Category": "SUV"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "C30",
    "Category": "Hatchback"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2008,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan, Wagon, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Bentley",
    "Model": "Arnage",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Buick",
    "Model": "Rendezvous",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "Q7",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "Alpina B7",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Sedan, Convertible, Wagon"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "Z4 M",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "RS 4",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Bentley",
    "Model": "Azure",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Avalanche",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "XLR",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Buick",
    "Model": "Lucerne",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Buick",
    "Model": "Terraza",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Buick",
    "Model": "Rainier",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Cobalt",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "DTS",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "HHR",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "Crossfire",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Uplander Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado (Classic) 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Uplander Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "Aspen",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Caliber",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Nitro",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Magnum",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 1500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "E250 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Expedition EL",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "E150 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ferrari",
    "Model": "599 GTB Fiorano",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Ferrari",
    "Model": "F430",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Dodge",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ferrari",
    "Model": "612 Scaglietti",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "E150 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Freestar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Five Hundred",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Freestar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Freestyle",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Fit",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra (Classic) 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "HUMMER",
    "Model": "H3",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Veracruz",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Entourage",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Isuzu",
    "Model": "Ascender",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV, Pickup"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Jeep",
    "Model": "Commander",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Isuzu",
    "Model": "i-290 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Isuzu",
    "Model": "i-370 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Jeep",
    "Model": "Patriot",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Isuzu",
    "Model": "i-370 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Amanti",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Rondo",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Land Rover",
    "Model": "LR3",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lincoln",
    "Model": "MKX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Lamborghini",
    "Model": "Murcielago",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Lotus",
    "Model": "Exige S",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Lincoln",
    "Model": "Mark LT",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lincoln",
    "Model": "MKZ",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Mercury",
    "Model": "Milan",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "B-Series Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "CX-7",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Raider Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Mercury",
    "Model": "Montego",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "SLR McLaren",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Mercury",
    "Model": "Monterey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "GL-Class",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Mitsubishi",
    "Model": "Raider Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Saturn",
    "Model": "Aura",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Saab",
    "Model": "9-7X",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Pontiac",
    "Model": "G6",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Pontiac",
    "Model": "Solstice",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Pontiac",
    "Model": "Torrent",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Pontiac",
    "Model": "G5",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Wagon, Sedan, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Saturn",
    "Model": "Relay",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2007,
    "Make": "Saturn",
    "Model": "Ion",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Saturn",
    "Model": "Outlook",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Saturn",
    "Model": "SKY",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Suzuki",
    "Model": "SX4",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Subaru",
    "Model": "B9 Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Suzuki",
    "Model": "Aerio",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Suzuki",
    "Model": "XL7",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Suzuki",
    "Model": "Forenza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Suzuki",
    "Model": "Reno",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "FJ Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Yaris",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "Eos",
    "Category": "Convertible"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2007,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "Rabbit",
    "Category": "Hatchback"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Aston Martin",
    "Model": "Vanquish S",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Aston Martin",
    "Model": "Vantage",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Audi",
    "Model": "A3",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Convertible, Sedan, Wagon"
  },
  {
    "Year": 2007,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan, Wagon, Convertible"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Acura",
    "Model": "RSX",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Bentley",
    "Model": "Arnage",
    "Category": "Sedan"
  },
  {
    "Year": 2007,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Sedan, Convertible, Wagon"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Buick",
    "Model": "Lucerne",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "Z4 M",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Cobalt",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "M6",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Buick",
    "Model": "Rainier",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Buick",
    "Model": "Terraza",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Avalanche 2500",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "XLR",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "HHR",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Buick",
    "Model": "Rendezvous",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Cadillac",
    "Model": "DTS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Avalanche 1500",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Uplander Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "SSR",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chrysler",
    "Model": "Crossfire",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 3500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Chevrolet",
    "Model": "Uplander Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Magnum",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 1500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ferrari",
    "Model": "F430",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "E150 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "E150 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Ferrari",
    "Model": "612 Scaglietti",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "E250 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Fusion",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Five Hundred",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Freestar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "GT",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Freestyle",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Ford",
    "Model": "Freestar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Envoy XL",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "GMC",
    "Model": "Sierra 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "HUMMER",
    "Model": "H3",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "Wagon, SUV"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Jeep",
    "Model": "Commander",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Isuzu",
    "Model": "i-350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2006,
    "Make": "Isuzu",
    "Model": "i-280 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV, Pickup"
  },
  {
    "Year": 2006,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Hyundai",
    "Model": "Azera",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Optima (2006.5)",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Isuzu",
    "Model": "Ascender",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Amanti",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Lamborghini",
    "Model": "Murcielago",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Land Rover",
    "Model": "LR3",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Lamborghini",
    "Model": "Gallardo",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Lincoln",
    "Model": "Mark LT",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Lotus",
    "Model": "Exige",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Maserati",
    "Model": "GranSport",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Lincoln",
    "Model": "Zephyr",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "B-Series Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "MAZDA5",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Maserati",
    "Model": "Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mercury",
    "Model": "Monterey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "CLS-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "SLR McLaren",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Raider Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Raider Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "R-Class",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Mercury",
    "Model": "Montego",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mercury",
    "Model": "Milan",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "G6",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Panoz",
    "Model": "Esperante",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "GTO",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "Montana SV6",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "Solstice",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Porsche",
    "Model": "Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Subaru",
    "Model": "Baja",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Sedan, Convertible, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Saturn",
    "Model": "Ion",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2006,
    "Make": "Scion",
    "Model": "xA",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "Torrent",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2006,
    "Make": "Saturn",
    "Model": "Relay",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Subaru",
    "Model": "B9 Tribeca",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Saab",
    "Model": "9-2X",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Saab",
    "Model": "9-7X",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Suzuki",
    "Model": "XL-7",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2006,
    "Make": "Suzuki",
    "Model": "Forenza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2006,
    "Make": "Suzuki",
    "Model": "Aerio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Suzuki",
    "Model": "Reno",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Suzuki",
    "Model": "Verona",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "Rabbit",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2006,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Convertible, Wagon, Sedan"
  },
  {
    "Year": 2005,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Acura",
    "Model": "RSX",
    "Category": "Coupe"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Aston Martin",
    "Model": "Vanquish S",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "A4 (2005.5)",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "Phaeton",
    "Category": "Sedan"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2006,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Aston Martin",
    "Model": "DB9",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2005,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Bentley",
    "Model": "Arnage",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "Rainier",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "S4 (2005.5)",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Convertible, Wagon, Sedan"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Bentley",
    "Model": "Continental",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "LaCrosse",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "Rendezvous",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Avalanche 2500",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Cobalt",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Avalanche 1500",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Buick",
    "Model": "Terraza",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "STS",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Classic",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "XLR",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "SSR",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Magnum",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Uplander Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Uplander Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Chrysler",
    "Model": "Crossfire",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "E150 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Excursion",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "E150 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Freestyle",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Five Hundred",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "E250 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Envoy XUV",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Freestar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Freestar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "GT",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Envoy XL",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan, Hatchback"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "GMC",
    "Model": "Sierra 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "XG350",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV, Pickup"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2005,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Isuzu",
    "Model": "Ascender",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Amanti",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2005,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Maserati",
    "Model": "Coupe",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Land Rover",
    "Model": "LR3",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Maserati",
    "Model": "GranSport",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Land Rover",
    "Model": "Freelander",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Maserati",
    "Model": "Quattroporte",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Lincoln",
    "Model": "Aviator",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Lotus",
    "Model": "Elise",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Maybach",
    "Model": "57",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Maybach",
    "Model": "62",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "B-Series Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "MINI",
    "Model": "Convertible",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "SLR McLaren",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mercury",
    "Model": "Montego",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Mercury",
    "Model": "Mariner",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mercury",
    "Model": "Monterey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Panoz",
    "Model": "Esperante",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Armada",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Aztek",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "G6",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2005,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "GTO",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Montana SV6",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Scion",
    "Model": "tC",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Saab",
    "Model": "9-2X",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Rolls-Royce",
    "Model": "Phantom",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe"
  },
  {
    "Year": 2005,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Saab",
    "Model": "9-7X",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Saturn",
    "Model": "Ion",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2005,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Subaru",
    "Model": "Baja",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Convertible, Sedan"
  },
  {
    "Year": 2005,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Porsche",
    "Model": "Carrera GT",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Scion",
    "Model": "xA",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Saturn",
    "Model": "Relay",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2005,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Saturn",
    "Model": "L-Series",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Wagon, Convertible, Sedan"
  },
  {
    "Year": 2005,
    "Make": "Suzuki",
    "Model": "Reno",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Acura",
    "Model": "TSX",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Suzuki",
    "Model": "Aerio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Suzuki",
    "Model": "Forenza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2005,
    "Make": "Suzuki",
    "Model": "XL-7",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Suzuki",
    "Model": "Verona",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Echo",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Buick",
    "Model": "Rendezvous",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Convertible"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "Jetta (New)",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "6 Series",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Acura",
    "Model": "RSX",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "Phaeton",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Buick",
    "Model": "Rainier",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2005,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "V50",
    "Category": "Wagon"
  },
  {
    "Year": 2005,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Convertible, Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "SRX",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Avalanche 1500",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "XLR",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Avalanche 2500",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Aveo",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Colorado Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Classic",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "S10 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "Crossfire",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "300M",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "SSR",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Excursion",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "E150 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Dodge",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F150 (Heritage) Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "E250 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F150 (Heritage) Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Freestar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Freestar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Envoy XL",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Canyon Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Envoy XUV",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sonoma Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Sierra 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Hyundai",
    "Model": "XG350",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "Wagon, SUV"
  },
  {
    "Year": 2004,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Lincoln",
    "Model": "Aviator",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Kia",
    "Model": "Amanti",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Isuzu",
    "Model": "Axiom",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Isuzu",
    "Model": "Ascender",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan, Wagon, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Land Rover",
    "Model": "Freelander",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "RX-8",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Mercury",
    "Model": "Marauder",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Endeavor",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Mercury",
    "Model": "Monterey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Titan King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Oldsmobile",
    "Model": "Alero",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Aztek",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Titan Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Nissan",
    "Model": "Pathfinder Armada",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Porsche",
    "Model": "Carrera GT",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Pontiac",
    "Model": "GTO",
    "Category": "Coupe"
  },
  {
    "Year": 2004,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Suzuki",
    "Model": "Forenza",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Saturn",
    "Model": "Ion",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2004,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Subaru",
    "Model": "Baja",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Suzuki",
    "Model": "Aerio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Saturn",
    "Model": "L-Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Suzuki",
    "Model": "Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Suzuki",
    "Model": "Verona",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Scion",
    "Model": "xB",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Echo",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Hatchback, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Scion",
    "Model": "xA",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Suzuki",
    "Model": "XL-7",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "Phaeton",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "S40 (New)",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "R32",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "Touareg",
    "Category": "SUV"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "V40",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2004,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Wagon, Sedan, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Acura",
    "Model": "RSX",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Acura",
    "Model": "CL",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Wagon"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Convertible, Coupe, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "Z8",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "RS 6",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "Z4",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2003,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Cadillac",
    "Model": "CTS",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Buick",
    "Model": "Rendezvous",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Avalanche 2500",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Avalanche 1500",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "S10 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chrysler",
    "Model": "300M",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "SSR",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chrysler",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Grand Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Sprinter 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Sprinter 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "E250 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Explorer Sport",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "E150 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Excursion",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Wagon, Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "ZX2",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Envoy XL",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sonoma Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2003,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sonoma Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan, Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Hyundai",
    "Model": "XG350",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "HUMMER",
    "Model": "H2",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "Wagon, SUV"
  },
  {
    "Year": 2003,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "Element",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Isuzu",
    "Model": "Axiom",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "INFINITI",
    "Model": "FX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Isuzu",
    "Model": "Ascender",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Land Rover",
    "Model": "Freelander",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Isuzu",
    "Model": "Rodeo Sport",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Lincoln",
    "Model": "Aviator",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "Protege5",
    "Category": "Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mercury",
    "Model": "Marauder",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "350Z",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Outlander",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Oldsmobile",
    "Model": "Alero",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Echo",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Vibe",
    "Category": "Wagon"
  },
  {
    "Year": 2003,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Aztek",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Suzuki",
    "Model": "Aerio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Saturn",
    "Model": "L-Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Subaru",
    "Model": "Baja",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Saturn",
    "Model": "Ion",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Matrix",
    "Category": "Wagon"
  },
  {
    "Year": 2003,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Convertible, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Suzuki",
    "Model": "XL-7",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Suzuki",
    "Model": "Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Convertible"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Volkswagen",
    "Model": "Eurovan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2003,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2003,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Acura",
    "Model": "CL",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2003,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "V40",
    "Category": "Wagon"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Wagon"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Acura",
    "Model": "RSX",
    "Category": "Coupe"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "XC70",
    "Category": "Wagon"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2003,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Avalanche 1500",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Avalanche 2500",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "Z8",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Cadillac",
    "Model": "Escalade EXT",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Buick",
    "Model": "Rendezvous",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "BMW",
    "Model": "M",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "S10 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "Prowler",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "TrailBlazer",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Convertible, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Daewoo",
    "Model": "Nubira",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Daewoo",
    "Model": "Leganza",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Chrysler",
    "Model": "300M",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Daewoo",
    "Model": "Lanos",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Explorer Sport",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Econoline E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Excursion",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Wagon, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Envoy XL",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sonoma Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sonoma Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Isuzu",
    "Model": "Rodeo Sport",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Ford",
    "Model": "ZX2",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Jaguar",
    "Model": "X-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Sierra 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Hyundai",
    "Model": "XG350",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Isuzu",
    "Model": "Axiom",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Jeep",
    "Model": "Liberty",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Land Rover",
    "Model": "Discovery Series II",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Land Rover",
    "Model": "Freelander",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Lincoln",
    "Model": "Blackwood",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "Protege5",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "MINI",
    "Model": "Cooper",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 2002,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Mitsubishi",
    "Model": "Lancer",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Aztek",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Oldsmobile",
    "Model": "Intrigue",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Oldsmobile",
    "Model": "Alero",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Saturn",
    "Model": "L-Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Echo",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Saturn",
    "Model": "VUE",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Suzuki",
    "Model": "Aerio",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Suzuki",
    "Model": "XL-7",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Suzuki",
    "Model": "Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "Eurovan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2002,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "Z8",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Acura",
    "Model": "CL",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "S8",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2002,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2001,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2002,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2002,
    "Make": "Volvo",
    "Model": "V40",
    "Category": "Wagon"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "M",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2001,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Sedan, Wagon, Convertible"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Cadillac",
    "Model": "Catera",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Metro",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Coupe, Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "S10 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Daewoo",
    "Model": "Nubira",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Daewoo",
    "Model": "Leganza",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "300M",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Daewoo",
    "Model": "Lanos",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "Prowler",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Chrysler",
    "Model": "PT Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Econoline E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Excursion",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Explorer Sport",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 1500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sonoma Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Explorer Sport Trac",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Ford",
    "Model": "ZX2",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sonoma Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sierra 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "Wagon, SUV"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Isuzu",
    "Model": "Rodeo Sport",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Hyundai",
    "Model": "XG300",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2001,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Kia",
    "Model": "Optima",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Isuzu",
    "Model": "VehiCROSS",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Land Rover",
    "Model": "Discovery Series II",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "Tribute",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Frontier Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Aztek",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Oldsmobile",
    "Model": "Alero",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Oldsmobile",
    "Model": "Intrigue",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Suzuki",
    "Model": "XL-7",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Saturn",
    "Model": "L-Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Suzuki",
    "Model": "Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Convertible"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Echo",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "Eurovan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2001,
    "Make": "Volvo",
    "Model": "V40",
    "Category": "Wagon"
  },
  {
    "Year": 2001,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "Passat (New)",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback"
  },
  {
    "Year": 2001,
    "Make": "Volvo",
    "Model": "S60",
    "Category": "Sedan"
  },
  {
    "Year": 2001,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2001,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2000,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Audi",
    "Model": "TT",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Wagon, Convertible, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "Z8",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Cadillac",
    "Model": "Catera",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "M",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2000,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Metro",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Tahoe (New)",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "Cirrus",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "300M",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Daewoo",
    "Model": "Nubira",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Daewoo",
    "Model": "Lanos",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Daewoo",
    "Model": "Leganza",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Contour",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Econoline E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Dakota Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Excursion",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Explorer Sport",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Focus",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Yukon XL 2500",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra (Classic) 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Sedan, Hatchback"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra (Classic) 3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Yukon Denali",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra (Classic) 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra (Classic) 3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sonoma Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Yukon XL 1500",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra (Classic) 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "S2000",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra (Classic) 2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Isuzu",
    "Model": "Amigo",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "GMC",
    "Model": "Sierra 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Isuzu",
    "Model": "Hombre Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Isuzu",
    "Model": "Hombre Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Isuzu",
    "Model": "VehiCROSS",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Jaguar",
    "Model": "S-Type",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Lincoln",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Land Rover",
    "Model": "Discovery Series II",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Kia",
    "Model": "Spectra",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mercury",
    "Model": "Mystique",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Frontier Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Plymouth",
    "Model": "Breeze",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Xterra",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Oldsmobile",
    "Model": "Alero",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Saturn",
    "Model": "L-Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Oldsmobile",
    "Model": "Intrigue",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Echo",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Plymouth",
    "Model": "Prowler",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Suzuki",
    "Model": "Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Tundra Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "Eurovan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2000,
    "Make": "Toyota",
    "Model": "Tundra Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback"
  },
  {
    "Year": 2000,
    "Make": "Volvo",
    "Model": "S70",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Volvo",
    "Model": "V40",
    "Category": "Wagon"
  },
  {
    "Year": 1999,
    "Make": "Acura",
    "Model": "SLX",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 2000,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 2000,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 2000,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 2000,
    "Make": "Volvo",
    "Model": "S40",
    "Category": "Sedan"
  },
  {
    "Year": 2000,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Acura",
    "Model": "CL",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Hatchback, Convertible, Sedan"
  },
  {
    "Year": 1999,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Cadillac",
    "Model": "Catera",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1999,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Metro",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Express 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Express 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Daewoo",
    "Model": "Leganza",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Daewoo",
    "Model": "Lanos",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chrysler",
    "Model": "Cirrus",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 2500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Daewoo",
    "Model": "Nubira",
    "Category": "Wagon, Sedan, Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Contour",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Econoline E150 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Econoline E350 Super Duty Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F250 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F250 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F350 Super Duty Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F350 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "F350 Super Duty Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sierra 2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sonoma Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sierra 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Hatchback"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "Amigo",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sierra 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sierra 1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Hatchback, Sedan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Land Rover",
    "Model": "Discovery Series II",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1999,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "Hombre Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "VehiCROSS",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "Hombre Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Isuzu",
    "Model": "Oasis",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "Cutlass",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Mystique",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Frontier Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "Alero",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "Intrigue",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "LSS",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Plymouth",
    "Model": "Breeze",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Saab",
    "Model": "5-Sep",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Jetta (New)",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Volvo",
    "Model": "S80",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1999,
    "Make": "Saab",
    "Model": "3-Sep",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Solara",
    "Category": "Coupe"
  },
  {
    "Year": 1999,
    "Make": "Plymouth",
    "Model": "Prowler",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Cabrio (New)",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 1999,
    "Make": "Suzuki",
    "Model": "Grand Vitara",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Pontiac",
    "Model": "Montana",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1999,
    "Make": "Suzuki",
    "Model": "Vitara",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Eurovan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Golf (New)",
    "Category": "Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "GTI (New)",
    "Category": "Hatchback"
  },
  {
    "Year": 1999,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 1999,
    "Make": "Volvo",
    "Model": "S70",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1999,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1999,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 1999,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Acura",
    "Model": "CL",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Acura",
    "Model": "SLX",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 1998,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Audi",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1998,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Hatchback, Convertible, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Cadillac",
    "Model": "Catera",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible"
  },
  {
    "Year": 1998,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "G-Series 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "G-Series 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Hatchback, Sedan, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "G-Series 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Metro",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Venture Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 2500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Chrysler",
    "Model": "Cirrus",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Chevrolet",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 1500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 3500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram 2500 Quad Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Contour",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Sonoma Club Coupe Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Hatchback, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "2500 HD Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Isuzu",
    "Model": "Amigo",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Isuzu",
    "Model": "Oasis",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Envoy",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1998,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Isuzu",
    "Model": "Hombre Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Isuzu",
    "Model": "Hombre Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Mercury",
    "Model": "Mystique",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1998,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1998,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Lincoln",
    "Model": "Mark VIII",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "SLK-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1998,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "M-Class",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "CLK-Class",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Mercedes-Benz",
    "Model": "CL-Class",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "200SX",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Coupe"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Frontier Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 1998,
    "Make": "Plymouth",
    "Model": "Breeze",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Cutlass",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "LSS",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Regency",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1998,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 1998,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Oldsmobile",
    "Model": "Intrigue",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Saab",
    "Model": "900",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Coupe, Hatchback, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "T100 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Suzuki",
    "Model": "X-90",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1998,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "T100 Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1998,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 1998,
    "Make": "Volvo",
    "Model": "S70",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 1998,
    "Make": "Volvo",
    "Model": "C70",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Volkswagen",
    "Model": "New Beetle",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1997,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Hatchback, Convertible, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Acura",
    "Model": "SLX",
    "Category": "SUV"
  },
  {
    "Year": 1998,
    "Make": "Volvo",
    "Model": "V70",
    "Category": "Wagon"
  },
  {
    "Year": 1998,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1998,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1998,
    "Make": "Volvo",
    "Model": "V90",
    "Category": "Wagon"
  },
  {
    "Year": 1998,
    "Make": "Volvo",
    "Model": "S90",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Audi",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Acura",
    "Model": "CL",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Audi",
    "Model": "A8",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Cadillac",
    "Model": "Catera",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "G-Series 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "G-Series 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "G-Series 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chrysler",
    "Model": "Cirrus",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Venture Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Aerostar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram 2500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Aspire",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram 3500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Aerostar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Eagle",
    "Model": "Vision",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Probe",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Contour",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F250 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F350 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Geo",
    "Model": "Metro",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Geo",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Geo",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "2500 HD Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Hatchback, Sedan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Sonoma Club Coupe Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "del Sol",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1997,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Isuzu",
    "Model": "Hombre Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "INFINITI",
    "Model": "J",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Hyundai",
    "Model": "Tiburon",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "INFINITI",
    "Model": "QX",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Isuzu",
    "Model": "Oasis",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Isuzu",
    "Model": "Hombre Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Jaguar",
    "Model": "XK",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Land Rover",
    "Model": "Defender 90",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Mystique",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Lincoln",
    "Model": "Mark VIII",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Mountaineer",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "MAZDA",
    "Model": "MX-6",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Cutlass",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "Montero Sport",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "200SX",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Nissan",
    "Model": "King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Cutlass Supreme",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Plymouth",
    "Model": "Breeze",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Regency",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Saab",
    "Model": "900",
    "Category": "Coupe, Hatchback, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Coupe, Wagon, Sedan"
  },
  {
    "Year": 1997,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 1997,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Plymouth",
    "Model": "Prowler",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Suzuki",
    "Model": "X-90",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Porsche",
    "Model": "Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1997,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Oldsmobile",
    "Model": "LSS",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Subaru",
    "Model": "SVX",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback, Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "T100 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "T100 Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Paseo",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Acura",
    "Model": "SLX",
    "Category": "SUV"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Audi",
    "Model": "A4",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 1997,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Audi",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1996,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Hatchback, Coupe, Sedan, Convertible"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Previa",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "BMW",
    "Model": "Z3",
    "Category": "Convertible"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Volvo",
    "Model": "850",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1997,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Volvo",
    "Model": "960",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe"
  },
  {
    "Year": 1997,
    "Make": "Volvo",
    "Model": "V90",
    "Category": "Wagon"
  },
  {
    "Year": 1996,
    "Make": "Acura",
    "Model": "RL",
    "Category": "Sedan"
  },
  {
    "Year": 1997,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 1997,
    "Make": "Volvo",
    "Model": "S90",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "Roadmaster",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Express 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Express 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Cadillac",
    "Model": "Fleetwood",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "G-Series 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "2500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Beretta",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "G-Series G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "G-Series 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Lumina Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Sportvan G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Corsica",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Lumina Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Express 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Caprice Classic",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Chrysler",
    "Model": "Cirrus",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram 3500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Chrysler",
    "Model": "New Yorker",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram 2500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Stealth",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Contour",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Eagle",
    "Model": "Vision",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Aerostar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Bronco",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Aerostar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Aspire",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Eagle",
    "Model": "Summit",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F350 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F250 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Probe",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "F350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Sonoma Club Coupe Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Geo",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Savana 2500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Geo",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Savana 1500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Savana 1500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Savana 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Geo",
    "Model": "Metro",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Savana 2500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan, Coupe, Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Honda",
    "Model": "del Sol",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Rally Wagon G3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1996,
    "Make": "INFINITI",
    "Model": "J",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Savana 3500 Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Vandura G3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "INFINITI",
    "Model": "I",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Isuzu",
    "Model": "Hombre Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Isuzu",
    "Model": "Oasis",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Lincoln",
    "Model": "Mark VIII",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "MX-6",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Mercury",
    "Model": "Mystique",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "300ZX",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Plymouth",
    "Model": "Breeze",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "200SX",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "Ciera",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "98",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Oldsmobile",
    "Model": "Cutlass Supreme",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Saab",
    "Model": "900",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Suzuki",
    "Model": "X-90",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Subaru",
    "Model": "SVX",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1996,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback, Convertible, Coupe"
  },
  {
    "Year": 1996,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 1996,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "BMW",
    "Model": "M3",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "T100 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Alfa Romeo",
    "Model": "164",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Acura",
    "Model": "TL",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Previa",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Audi",
    "Model": "A6",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1996,
    "Make": "Volvo",
    "Model": "850",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Audi",
    "Model": "90",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Convertible"
  },
  {
    "Year": 1996,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Acura",
    "Model": "Legend",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Audi",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Hatchback, Sedan, Coupe, Convertible"
  },
  {
    "Year": 1996,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Volvo",
    "Model": "960",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Paseo",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "T100 Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1996,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "Roadmaster",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "G-Series G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Caprice Classic",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Corsica",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Cadillac",
    "Model": "Fleetwood",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Beretta",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "3500 HD Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "G-Series G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "G-Series G10",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "3500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "Cirrus",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "LeBaron",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram 2500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Monte Carlo",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Avenger",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Sportvan G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Lumina Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Neon",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Sportvan G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Lumina Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "Sebring",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "New Yorker",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Aerostar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram Van 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Contour",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Eagle",
    "Model": "Summit",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram 3500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram Van 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram Van 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram 1500 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Stealth",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Spirit",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Stratus",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Eagle",
    "Model": "Vision",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Dodge",
    "Model": "Ram Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Bronco",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Aspire",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Aerostar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Convertible, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Hatchback, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F350 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Windstar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Probe",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Geo",
    "Model": "Metro",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Windstar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Geo",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Geo",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Rally Wagon G3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Rally Wagon G2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Sonoma Club Coupe Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Hatchback, Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Vandura G2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Vandura G3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Vandura G1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Honda",
    "Model": "del Sol",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Hyundai",
    "Model": "Scoupe",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 1995,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Isuzu",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "INFINITI",
    "Model": "J",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1995,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Land Rover",
    "Model": "Defender 90",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "MX-3",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "MX-6",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "929",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Lincoln",
    "Model": "Mark VIII",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Expo",
    "Category": "Wagon"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Coupe, Convertible, Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "Millenia",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "MAZDA",
    "Model": "RX-7",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Mercury",
    "Model": "Mystique",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "300ZX",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "200SX",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "Aurora",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Plymouth",
    "Model": "Acclaim",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "98",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "Cutlass Supreme",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "Cutlass Ciera",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Plymouth",
    "Model": "Neon",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Suzuki",
    "Model": "Samurai",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1995,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Porsche",
    "Model": "968",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1995,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Pontiac",
    "Model": "Sunfire",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Porsche",
    "Model": "928",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Saab",
    "Model": "900",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1995,
    "Make": "Subaru",
    "Model": "SVX",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Suzuki",
    "Model": "Esteem",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Paseo",
    "Category": "Coupe"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1995,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "T100 Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "T100 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Tacoma Xtracab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Volvo",
    "Model": "850",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Hatchback"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Previa",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback, Convertible, Coupe"
  },
  {
    "Year": 1995,
    "Make": "Volkswagen",
    "Model": "Cabrio",
    "Category": "Convertible"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Volkswagen",
    "Model": "Golf III",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Audi",
    "Model": "Quattro",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Alfa Romeo",
    "Model": "Spider",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Alfa Romeo",
    "Model": "164",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Xtra Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1995,
    "Make": "Toyota",
    "Model": "Tacoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Volkswagen",
    "Model": "Jetta III",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Audi",
    "Model": "90",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Acura",
    "Model": "Legend",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Audi",
    "Model": "100",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Acura",
    "Model": "Vigor",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Audi",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Buick",
    "Model": "Roadmaster",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1995,
    "Make": "Volvo",
    "Model": "960",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1995,
    "Make": "Volvo",
    "Model": "940",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "G-Series G10",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "G-Series G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Caprice Classic",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Cadillac",
    "Model": "Fleetwood",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "G-Series G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Beretta",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Corsica",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Lumina Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Sedan, Coupe, Wagon, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Sportvan G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Impala",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Lumina Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Sportvan G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "S10 Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Chrysler",
    "Model": "LHS",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chrysler",
    "Model": "LeBaron",
    "Category": "Sedan, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram Van B250",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram Wagon B350",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram 3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram 2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram 1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Colt",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chrysler",
    "Model": "New Yorker",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram Van B150",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram Van B350",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram Wagon B150",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Stealth",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Shadow",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Bronco",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Aspire",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Eagle",
    "Model": "Vision",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Spirit",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Dodge",
    "Model": "Ram Wagon B250",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Eagle",
    "Model": "Summit",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Aerostar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Aerostar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F350 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "F350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Probe",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Geo",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Rally Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Geo",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Ford",
    "Model": "Tempo",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Geo",
    "Model": "Metro",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Rally Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Vandura 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Isuzu",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Sonoma Club Coupe Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Hatchback, Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Vandura 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Vandura 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "INFINITI",
    "Model": "J",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Honda",
    "Model": "del Sol",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Isuzu",
    "Model": "Amigo",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Hyundai",
    "Model": "Scoupe",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Hyundai",
    "Model": "Excel",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1994,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Isuzu",
    "Model": "Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Land Rover",
    "Model": "Defender 90",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Kia",
    "Model": "Sephia",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Lincoln",
    "Model": "Mark VIII",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "323",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "929",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "MX-3",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "Navajo",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "MX-6",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Capri",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "RX-7",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Mercedes-Benz",
    "Model": "S-Class",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Mercedes-Benz",
    "Model": "E-Class",
    "Category": "Coupe, Convertible, Wagon, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Expo",
    "Category": "Wagon"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Macro Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Precis",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mercedes-Benz",
    "Model": "SL-Class",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Topaz",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "300ZX",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "Cutlass Supreme",
    "Category": "Convertible, Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Laser",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "Cutlass Ciera",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "98",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "Cutlass Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Colt",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Acclaim",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Colt Vista",
    "Category": "Wagon"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Pontiac",
    "Model": "Sunbird",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Nissan",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Convertible, Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Subaru",
    "Model": "Loyale",
    "Category": "Wagon"
  },
  {
    "Year": 1994,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "T100 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Coupe, Wagon, Sedan"
  },
  {
    "Year": 1994,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Hatchback, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1994,
    "Make": "Plymouth",
    "Model": "Sundance",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Previa",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Porsche",
    "Model": "928",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Saab",
    "Model": "900",
    "Category": "Coupe, Hatchback, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Subaru",
    "Model": "SVX",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Paseo",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Porsche",
    "Model": "968",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1994,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Subaru",
    "Model": "Justy",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Suzuki",
    "Model": "Samurai",
    "Category": "SUV"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Volkswagen",
    "Model": "Corrado",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Toyota",
    "Model": "Xtra Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Cadillac",
    "Model": "Allante",
    "Category": "Convertible"
  },
  {
    "Year": 1994,
    "Make": "Volvo",
    "Model": "940",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1994,
    "Make": "Volkswagen",
    "Model": "Golf III",
    "Category": "Hatchback"
  },
  {
    "Year": 1994,
    "Make": "Volvo",
    "Model": "960",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 1994,
    "Make": "Volkswagen",
    "Model": "Jetta III",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Acura",
    "Model": "Vigor",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Alfa Romeo",
    "Model": "Spider",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Acura",
    "Model": "Integra",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Acura",
    "Model": "Legend",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Audi",
    "Model": "90",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Cadillac",
    "Model": "Fleetwood",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Audi",
    "Model": "Quattro",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Alfa Romeo",
    "Model": "164",
    "Category": "Sedan"
  },
  {
    "Year": 1994,
    "Make": "Volvo",
    "Model": "850",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Sedan, Wagon, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Audi",
    "Model": "100",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Cadillac",
    "Model": "Sixty Special",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Buick",
    "Model": "Roadmaster",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Beretta",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "S10 Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Sportvan G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "G-Series G10",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Corsica",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Caprice Classic",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Lumina APV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chrysler",
    "Model": "Concorde",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Sportvan G10",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "G-Series G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Chrysler",
    "Model": "LeBaron",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "APV Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram Van B250",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "D350 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Chrysler",
    "Model": "Fifth Ave",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Coupe, Sedan, Wagon, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "D250 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "G-Series G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Colt",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Sportvan G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "D150 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chrysler",
    "Model": "New Yorker",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chrysler",
    "Model": "Imperial",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "D350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "D150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram Wagon B250",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "D250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Dynasty",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram 50 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Daytona",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Stealth",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Intrepid",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram Van B350",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram Wagon B350",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram Van B150",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Shadow",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ramcharger",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Spirit",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Eagle",
    "Model": "Summit",
    "Category": "Sedan, Coupe, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Dodge",
    "Model": "Ram Wagon B150",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Eagle",
    "Model": "Vision",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Aerostar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Aerostar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Bronco",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Geo",
    "Model": "Metro",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Festiva",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Probe",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Tempo",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Geo",
    "Model": "Storm",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Geo",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "F350 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1993,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Geo",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Rally Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Coupe, Wagon, Sedan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "HUMMER",
    "Model": "H1",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Rally Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Vandura 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "INFINITI",
    "Model": "J",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Honda",
    "Model": "del Sol",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Sonoma Club Coupe Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Isuzu",
    "Model": "Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Vandura 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Rally Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Coupe, Hatchback, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Isuzu",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Isuzu",
    "Model": "Stylus",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Hyundai",
    "Model": "Scoupe",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "GMC",
    "Model": "Vandura 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Isuzu",
    "Model": "Amigo",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Hyundai",
    "Model": "Excel",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "929",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Land Rover",
    "Model": "Defender 110",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "323",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "Navajo",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Lincoln",
    "Model": "Mark VIII",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "MX-3",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Lexus",
    "Model": "GS",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "RX-7",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "MX-6",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 E",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "190 E",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 D",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 SD",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 CE",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "500 SEL",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "400 SEL",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "500 SL",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "500 E",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 SL",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "600 SEC",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 TE",
    "Category": "Wagon"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "400 E",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "300 SE",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "600 SL",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Expo",
    "Category": "Wagon"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "600 SEL",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Villager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Mercedes-Benz",
    "Model": "500 SEC",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Topaz",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Capri",
    "Category": "Convertible"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Macro Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Precis",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Sundance",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Colt Vista",
    "Category": "Wagon"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "98",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Hatchback, Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "Cutlass Supreme",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "300ZX",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "NX",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Acclaim",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Nissan",
    "Model": "Quest",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Laser",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "Cutlass Ciera",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "Cutlass Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 1993,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Plymouth",
    "Model": "Colt",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Porsche",
    "Model": "928",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Suzuki",
    "Model": "Samurai",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "Sunbird",
    "Category": "Coupe, Sedan, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "LeMans",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Coupe, Hatchback, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Saab",
    "Model": "900",
    "Category": "Hatchback, Sedan, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Porsche",
    "Model": "968",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1993,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Subaru",
    "Model": "Justy",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Subaru",
    "Model": "Loyale",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Corrado",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Volvo",
    "Model": "940",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Subaru",
    "Model": "SVX",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Previa",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "T100 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Paseo",
    "Category": "Coupe"
  },
  {
    "Year": 1993,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Golf III",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Xtra Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Jetta III",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1993,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Acura",
    "Model": "Legend",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1993,
    "Make": "Volvo",
    "Model": "960",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Eurovan",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1993,
    "Make": "Volvo",
    "Model": "850",
    "Category": "Sedan"
  },
  {
    "Year": 1993,
    "Make": "Volkswagen",
    "Model": "Fox",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1993,
    "Make": "Volvo",
    "Model": "240",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Acura",
    "Model": "NSX",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Acura",
    "Model": "Vigor",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Audi",
    "Model": "S4",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Alfa Romeo",
    "Model": "164",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Alfa Romeo",
    "Model": "Spider",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Audi",
    "Model": "100",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "BMW",
    "Model": "5 Series",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Audi",
    "Model": "Quattro",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "BMW",
    "Model": "7 Series",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "LeSabre",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Coupe, Convertible, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Audi",
    "Model": "80",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "BMW",
    "Model": "M5",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Cadillac",
    "Model": "Seville",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Cadillac",
    "Model": "Fleetwood",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "2500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "Skylark",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Cadillac",
    "Model": "Eldorado",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Cadillac",
    "Model": "Brougham",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Cadillac",
    "Model": "DeVille",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "Riviera",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Cadillac",
    "Model": "Allante",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Caprice",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "APV Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "Century",
    "Category": "Coupe, Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "BMW",
    "Model": "8 Series",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "Park Avenue",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "1500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Astro Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "Roadmaster",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "G-Series G10",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "3500 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "G-Series G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Buick",
    "Model": "Regal",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Astro Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "S10 Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "G-Series G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Beretta",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Sportvan G20",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Sportvan G30",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "S10 Blazer",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Chrysler",
    "Model": "New Yorker",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chrysler",
    "Model": "Imperial",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Lumina APV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Cavalier",
    "Category": "Coupe, Sedan, Wagon, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Lumina",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Corsica",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "S10 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Daihatsu",
    "Model": "Rocky",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Chrysler",
    "Model": "LeBaron",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Dakota Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Sportvan G10",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "D250 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Chrysler",
    "Model": "Fifth Ave",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Chevrolet",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Daihatsu",
    "Model": "Charade",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Caravan Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Monaco",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "D150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Daytona",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Chrysler",
    "Model": "Town & Country",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "D250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Dakota Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Colt",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Stealth",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram Van B250",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ramcharger",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram 50 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Econoline E150 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Econoline E250 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Viper",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram Wagon B250",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "D150 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram Van B150",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram Wagon B150",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Aerostar Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Dynasty",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram Wagon B350",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "D350 Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "D350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Eagle",
    "Model": "Summit",
    "Category": "Sedan, Hatchback, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Spirit",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Grand Caravan Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Aerostar Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Crown Victoria",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Ram Van B350",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Dodge",
    "Model": "Shadow",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Eagle",
    "Model": "Talon",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Eagle",
    "Model": "Premier",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Bronco",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Club Wagon",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F350 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Ranger Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F150 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Probe",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F150 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F250 Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Econoline E350 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Escort",
    "Category": "Hatchback, Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F350 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Geo",
    "Model": "Prizm",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Tempo",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Ranger Super Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F250 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Geo",
    "Model": "Tracker",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Festiva",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Thunderbird",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "F350 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Ford",
    "Model": "Taurus",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Sonoma Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Rally Wagon 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Sonoma Club Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Geo",
    "Model": "Metro",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "2500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Jimmy",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Geo",
    "Model": "Storm",
    "Category": "Coupe, Hatchback"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "2500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "3500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "1500 Club Coupe",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Rally Wagon 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Safari Passenger",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Rally Wagon 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Safari Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "3500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "3500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "1500 Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Suburban 1500",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Vandura 3500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Suburban 2500",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Honda",
    "Model": "Prelude",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "INFINITI",
    "Model": "M",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Coupe, Wagon, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Rodeo",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "INFINITI",
    "Model": "G",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Vandura 2500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Hyundai",
    "Model": "Scoupe",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Hyundai",
    "Model": "Excel",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Vandura 1500",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Impulse",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Amigo",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Jaguar",
    "Model": "XJ",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Spacecab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "INFINITI",
    "Model": "Q",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Trooper",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "626",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "MX-3",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "Protege",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 D",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Isuzu",
    "Model": "Stylus",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "323",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Jeep",
    "Model": "Comanche Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 SE",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Lexus",
    "Model": "SC",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "Navajo",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Lincoln",
    "Model": "Mark VII",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 CE",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "190 E",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "MX-6",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Lincoln",
    "Model": "Town Car",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Lincoln",
    "Model": "Continental",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "B-Series Cab Plus",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "B-Series Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 E",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "400 E",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "MPV",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "MAZDA",
    "Model": "929",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 SD",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 SL",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "500 E",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "300 TE",
    "Category": "Wagon"
  },
  {
    "Year": 1992,
    "Make": "Mercury",
    "Model": "Cougar",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Mercury",
    "Model": "Grand Marquis",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "500 SL",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "400 SE",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "600 SEL",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercedes-Benz",
    "Model": "500 SEL",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mercury",
    "Model": "Capri",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Mercury",
    "Model": "Sable",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Mercury",
    "Model": "Tracer",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Mercury",
    "Model": "Topaz",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Montero",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Expo",
    "Category": "Wagon"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "3000GT",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Mighty Max Macro Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Precis",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Diamante",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "NX",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Mirage",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Eclipse",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "240SX",
    "Category": "Hatchback, Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Mitsubishi",
    "Model": "Galant",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "300ZX",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Bravada",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "Stanza",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Toronado",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Cutlass Supreme",
    "Category": "Sedan, Convertible, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Colt",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Silhouette",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Cutlass Ciera",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Achieva",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "98",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "Custom Cruiser",
    "Category": "Wagon"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Colt Vista",
    "Category": "Wagon"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Laser",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Acclaim",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "Bonneville",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Oldsmobile",
    "Model": "88",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Sundance",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Plymouth",
    "Model": "Grand Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "Sunbird",
    "Category": "Sedan, Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "Firebird",
    "Category": "Hatchback, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Saab",
    "Model": "9000",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "Grand Am",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "LeMans",
    "Category": "Hatchback, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Saab",
    "Model": "900",
    "Category": "Sedan, Hatchback, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "Grand Prix",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Pontiac",
    "Model": "Trans Sport",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Porsche",
    "Model": "968",
    "Category": "Coupe, Convertible"
  },
  {
    "Year": 1992,
    "Make": "Suzuki",
    "Model": "Samurai",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Saturn",
    "Model": "S-Series",
    "Category": "Coupe, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Celica",
    "Category": "Coupe, Convertible, Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Subaru",
    "Model": "Justy",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Subaru",
    "Model": "SVX",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Suzuki",
    "Model": "Sidekick",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Subaru",
    "Model": "Loyale",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Suzuki",
    "Model": "Swift",
    "Category": "Sedan, Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Cressida",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "MR2",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Tercel",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Xtra Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "Cabriolet",
    "Category": "Convertible"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Supra",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Previa",
    "Category": "Van/Minivan"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "GTI",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "Corrado",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Paseo",
    "Category": "Coupe"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 1992,
    "Make": "Volvo",
    "Model": "740",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "Fox",
    "Category": "Sedan, Coupe"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 1992,
    "Make": "Volvo",
    "Model": "240",
    "Category": "Wagon, Sedan"
  },
  {
    "Year": 1992,
    "Make": "Volvo",
    "Model": "960",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 1992,
    "Make": "Volvo",
    "Model": "940",
    "Category": "Sedan, Wagon"
  },
  {
    "Year": 2021,
    "Make": "Acura",
    "Model": "ILX",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "A6 allroad",
    "Category": "Wagon"
  },
  {
    "Year": 2021,
    "Make": "Acura",
    "Model": "RDX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "S5",
    "Category": "Convertible,Sedan,Coupe"
  },
  {
    "Year": 2021,
    "Make": "Alfa Romeo",
    "Model": "Giulia",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "BMW",
    "Model": "X7",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "A7",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "CT5",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "S6",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Buick",
    "Model": "Enclave",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Acura",
    "Model": "TLX",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "BMW",
    "Model": "X5",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Buick",
    "Model": "Encore",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Buick",
    "Model": "Envision",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "Q3",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "Q5",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Buick",
    "Model": "Encore GX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Alfa Romeo",
    "Model": "Stelvio",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "BMW",
    "Model": "X1",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "BMW",
    "Model": "3 Series",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Audi",
    "Model": "Q8",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "BMW",
    "Model": "X3",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Malibu",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Colorado Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Blazer",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Bolt EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Express 3500 Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "XT6",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Colorado Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "XT5",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "Escalade ESV",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Camaro",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "XT4",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Spark",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Silverado 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "Escalade",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Cadillac",
    "Model": "CT4",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Silverado 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Trailblazer",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Regular Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Corvette",
    "Category": "Convertible,Coupe"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Tahoe",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Suburban",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Silverado 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Chrysler",
    "Model": "Voyager",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Chrysler",
    "Model": "Pacifica",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Chevrolet",
    "Model": "Trax",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Chrysler",
    "Model": "300",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Dodge",
    "Model": "Challenger",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Dodge",
    "Model": "Charger",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Escape",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Edge",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Bronco Sport",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "EcoSport",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Expedition",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "FIAT",
    "Model": "500X",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Dodge",
    "Model": "Durango",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Expedition MAX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Canyon Extended Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Ranger SuperCrew",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "F250 Super Duty Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "F150 SuperCrew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Transit Connect Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Genesis",
    "Model": "G70",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Sierra 3500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Explorer",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Canyon Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Sierra 1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Sierra 2500 HD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Ford",
    "Model": "Mustang",
    "Category": "Coupe,Convertible"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Acadia",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Genesis",
    "Model": "G80",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Yukon",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Yukon XL",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Genesis",
    "Model": "G90",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "GMC",
    "Model": "Terrain",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Genesis",
    "Model": "GV80",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Odyssey",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Accord Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Insight",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Passport",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "HR-V",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "CR-V",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Hatchback,Sedan"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Civic Type R",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Accord",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Ioniq Electric",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Ridgeline",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Accent",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "Pilot",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Elantra",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Honda",
    "Model": "CR-V Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Ioniq Plug-in Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Ioniq Hybrid",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Palisade",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Kona Electric",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Santa Fe",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Kona",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Sonata Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Sonata",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Wrangler",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Venue",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Veloster",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Forte",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Gladiator",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Jaguar",
    "Model": "E-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Telluride",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Renegade",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "INFINITI",
    "Model": "Q50",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "INFINITI",
    "Model": "QX50",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Sportage",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Jaguar",
    "Model": "I-PACE",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Grand Cherokee",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "K5",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Wrangler Unlimited",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "INFINITI",
    "Model": "QX80",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Land Rover",
    "Model": "Discovery",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Grand Cherokee L",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Soul",
    "Category": "Wagon"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Rio",
    "Category": "Hatchback,Sedan"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Stinger",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Sedona",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Jeep",
    "Model": "Compass",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Kia",
    "Model": "Seltos",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "ES",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Land Rover",
    "Model": "Range Rover",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Land Rover",
    "Model": "Range Rover Sport",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "GX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Land Rover",
    "Model": "Range Rover Velar",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "IS",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "LC",
    "Category": "Coupe,Convertible"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "LX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "LS",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "RC",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "NX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lincoln",
    "Model": "Nautilus",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lincoln",
    "Model": "Aviator",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "CX-30",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "RX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lincoln",
    "Model": "Navigator L",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lexus",
    "Model": "UX",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lincoln",
    "Model": "Corsair",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "CX-3",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Lincoln",
    "Model": "Navigator",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "CX-5",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "CX-9",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "MAZDA6",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "Mercedes-AMG G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "G-Class",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "MAZDA3",
    "Category": "Hatchback,Sedan"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "GLC",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "A-Class",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "MX-5 Miata RF",
    "Category": "Convertible"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "GLE",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "MAZDA",
    "Model": "MX-5 Miata",
    "Category": "Convertible"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "GLA",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Frontier King Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Kicks",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Altima",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Mitsubishi",
    "Model": "Outlander Sport",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Mercedes-Benz",
    "Model": "GLB",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "718 Spyder",
    "Category": "Convertible"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Maxima",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Polestar",
    "Model": "2",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "718 Boxster",
    "Category": "Convertible"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Murano",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "NV3500 HD Cargo",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "Macan",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Rogue",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "718 Cayman",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "LEAF",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "TITAN XD Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "911",
    "Category": "Coupe,Convertible"
  },
  {
    "Year": 2021,
    "Make": "Ram",
    "Model": "1500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Sentra",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Nissan",
    "Model": "Versa",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "Taycan",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "Cayenne",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "Panamera",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Ram",
    "Model": "2500 Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Porsche",
    "Model": "Cayenne Coupe",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Subaru",
    "Model": "Legacy",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Subaru",
    "Model": "Crosstrek",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Subaru",
    "Model": "Ascent",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ram",
    "Model": "ProMaster City",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Subaru",
    "Model": "Forester",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ram",
    "Model": "ProMaster Cargo Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Subaru",
    "Model": "Outback",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Ram",
    "Model": "ProMaster Window Van",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Ram",
    "Model": "2500 Mega Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Subaru",
    "Model": "Impreza",
    "Category": "Wagon,Sedan"
  },
  {
    "Year": 2021,
    "Make": "Rivian",
    "Model": "R1S",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Rivian",
    "Model": "R1T",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Tesla",
    "Model": "Model S",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "4Runner",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Tesla",
    "Model": "Model X",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Avalon Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Avalon",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Corolla",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Corolla Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Camry",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Camry Hybrid",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "GR Supra",
    "Category": "Coupe"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "C-HR",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Corolla Hatchback",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Prius Prime",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Prius",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "RAV4",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Highlander Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Highlander",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Land Cruiser",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "RAV4 Hybrid",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "RAV4 Prime",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Venza",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Sequoia",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Volvo",
    "Model": "S90",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Tundra Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Tacoma Double Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Volkswagen",
    "Model": "Atlas Cross Sport",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Tundra CrewMax",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Sienna",
    "Category": "Van/Minivan"
  },
  {
    "Year": 2021,
    "Make": "Volkswagen",
    "Model": "Atlas",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Volkswagen",
    "Model": "Jetta",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Volkswagen",
    "Model": "Golf",
    "Category": "Hatchback"
  },
  {
    "Year": 2021,
    "Make": "Toyota",
    "Model": "Tacoma Access Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2021,
    "Make": "Volkswagen",
    "Model": "Passat",
    "Category": "Sedan"
  },
  {
    "Year": 2021,
    "Make": "Volvo",
    "Model": "XC90",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Volvo",
    "Model": "V90",
    "Category": "Wagon"
  },
  {
    "Year": 2021,
    "Make": "Volvo",
    "Model": "XC60",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Volvo",
    "Model": "XC40",
    "Category": "SUV"
  },
  {
    "Year": 2021,
    "Make": "Volvo",
    "Model": "V60",
    "Category": "Wagon"
  },
  {
    "Year": 2022,
    "Make": "Chevrolet",
    "Model": "Equinox",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Acura",
    "Model": "MDX",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Subaru",
    "Model": "BRZ",
    "Category": "Coupe"
  },
  {
    "Year": 2022,
    "Make": "GMC",
    "Model": "Hummer EV",
    "Category": "Pickup"
  },
  {
    "Year": 2022,
    "Make": "Volkswagen",
    "Model": "Tiguan",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Chevrolet",
    "Model": "Traverse",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Jeep",
    "Model": "Grand Wagoneer",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Honda",
    "Model": "Civic",
    "Category": "Sedan"
  },
  {
    "Year": 2022,
    "Make": "Hyundai",
    "Model": "Tucson",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Mitsubishi",
    "Model": "Eclipse Cross",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Chevrolet",
    "Model": "Bolt EV",
    "Category": "Hatchback"
  },
  {
    "Year": 2022,
    "Make": "Nissan",
    "Model": "Frontier Crew Cab",
    "Category": "Pickup"
  },
  {
    "Year": 2022,
    "Make": "Nissan",
    "Model": "Pathfinder",
    "Category": "SUV"
  },
  {
    "Year": 2022,
    "Make": "Mercedes-Benz",
    "Model": "C-Class",
    "Category": "Coupe"
  },
  {
    "Year": 2022,
    "Make": "Kia",
    "Model": "Sorento",
    "Category": "SUV"
  }
];

const uniqueValues = (arr: any[]) => ([...(arr.filter((v, i, a) => a.indexOf(v) == i).sort()), "Other"]);

export const makes = () => uniqueValues(cars.map(c => c.Make)) as string[];
export const models = (make) => uniqueValues(cars.filter(c => c.Make === make).map(c => c.Model)) as string[];
export const modelYears = (make, model) => uniqueValues(cars.filter(c => c.Make === make && c.Model === model).map(c => c.Year)) as string[];